import { Injectable } from '@angular/core';
import { FormIdentifier } from '../../project/models/form-identifier.model';
import { Payment } from '../../fiscal/models/payment.model';
import { Project } from '../../project/models/project.model';
import { ProjectDetailService } from '../../project/services/project-shared.service';
import { ProjectForm } from '../../project/models/form.model';
import { FormPayment } from '../models/form-payment.model';
import {Subject, Observable} from 'rxjs';
import { UserFormPermissions } from '../models/permissions.model';
import { FormAction, formTypes, oneToOneFormTypes } from '../form.constants';
import { doFormIdsMatch } from '../form.functions';
import { UserDataService } from '../../user/services/user-data.service';
import { User } from '../../user/models/user.model';
import { LookupHttpService } from '../../fastlane-common/services/lookup-http.service';
import { PayPointReturnCode, feeTypes } from '../../fiscal/fiscal.constants';
import { Credit } from '../../entertainment/models/film/credit.model';
import {
  incentiveProgram,
  incentiveCategory,
  ITE2025LegislationStartDate,
  legislationRuleNames
} from '../../project/project.constants';
import { Project as FilmProject } from '../../entertainment/models/film/project.model';
import { Project as DigitalProject } from '../../entertainment/models/digital/project.model';
import { Project as PrrProject } from '../../core/models/project.model';

import { EntertainmentForm } from '../../entertainment/models/entertainment-form.model';
import { OutgoingPayment } from '../../fiscal/models/outgoing-payment.model';
import { ProjectBase } from '../../project/models/project-base.model';
import { AuditInfo } from '../../entertainment/interfaces/audit-info.interface';
import {StepForm} from '../../step/models/step-form.model';
import { Project as StepProject} from '../../step/models/step/project.model';
import {StepApplication} from '../../step/models/step/step-application.model';
import {PublicRecords} from '../../core/models/public-records.model';
import { SignaturesSendService } from '../../management/signatures/send/send.service';
import { Project as RdProject } from '../../rd/models/project.model';

@Injectable()
export class FormShareService {
  actions: FormAction[];
  formNewPayment: Payment;
  onFormIdChange: Subject<FormIdentifier>;
  payingContactIndex: number;
  permissions: UserFormPermissions;

  private _formId;

  // get castedForm() {
  //   switch (this.currentIncentiveProgram) {
  //     case incentiveProgram.film.code:
  //       return this.project.getProjectForm(this.formId) as ;
  //   }
  // }

  //#region assingingForm
  // This property is used only for BI forms.
  get form(): ProjectForm {
    return this.project.getProjectForm(this.formId);
  }

  private IrrevocableDesigneeLetterSentValue: boolean = null;
  private WaitingForSetIrrevocableDesigneeLetterSent = false;
  private IrrevocableDesigneeLetterExecutedValue: boolean = null;
  private WaitingForSetIrrevocableDesigneeLetterExecuted = false;

  SetIrrevocableDesigneeLetterSent() {
    if (this.WaitingForSetIrrevocableDesigneeLetterSent) {
    } else {
      this.WaitingForSetIrrevocableDesigneeLetterSent = true;
      this.signaturesService.irrevocableDesigneeLetterSent(this.formId).subscribe(result => {
        this.IrrevocableDesigneeLetterSentValue = result;
        this.WaitingForSetIrrevocableDesigneeLetterSent = false
      });
    }
  }

  get IrrevocableDesigneeLetterSent(): boolean {
    if (this.IrrevocableDesigneeLetterSentValue === null) {
      this.SetIrrevocableDesigneeLetterSent();
    }
    return this.IrrevocableDesigneeLetterSentValue;
  }


  SetIrrevocableDesigneeLetterExecuted() {
    if (this.WaitingForSetIrrevocableDesigneeLetterExecuted) {
    } else {
      this.WaitingForSetIrrevocableDesigneeLetterExecuted = true;
      this.signaturesService.irrevocableDesigneeLetterExecuted(this.formId).subscribe(result => {
        this.IrrevocableDesigneeLetterExecutedValue = result;
        this.WaitingForSetIrrevocableDesigneeLetterExecuted = false
      });
    }

  }

  get IrrevocableDesigneeLetterExecuted(): boolean {
    if (this.IrrevocableDesigneeLetterExecutedValue === null) {
      this.SetIrrevocableDesigneeLetterExecuted();
    }
    return this.IrrevocableDesigneeLetterExecutedValue;
  }

  set form(value) {
    if (oneToOneFormTypes.includes(this.formId.formType)) {
      this.project[this.formId.formType] = value;
    } else {
      this.project[this.formId.formType][this.formId.formIndex] = value;
    }
  }

  // This property is used only for step forms.
  get stepForm(): StepApplication {
    return this.stepProject.getProjectForm(this.formId) as StepApplication;
  }

  set stepForm(value) {
    if (oneToOneFormTypes.includes(this.formId.formType)) {
      this.stepProject[this.formId.formType] = value;
    } else {
      this.stepProject[this.formId.formType][this.formId.formIndex] = value;
    }
  }

  // This property is used only for film forms.
  get filmForm(): EntertainmentForm {
    return this.filmProject.getProjectForm(this.formId) as EntertainmentForm;
  }

  set filmForm(value) {
    if (oneToOneFormTypes.includes(this.formId.formType)) {
      this.filmProject[this.formId.formType] = value;
    } else {
      this.filmProject[this.formId.formType][this.formId.formIndex] = value;
    }
  }

  get auditInfo(): AuditInfo {
    return (this.filmForm as any) as AuditInfo;
  }

  // This property is used only for digital forms.
  get digitalForm(): EntertainmentForm {
    return this.digitalProject.getProjectForm(this.formId) as EntertainmentForm;
  }

  set digitalForm(value) {
    if (oneToOneFormTypes.includes(this.formId.formType)) {
      this.digitalProject[this.formId.formType] = value;
    } else {
      this.digitalProject[this.formId.formType][this.formId.formIndex] = value;
    }
  }
  //#endregion
  get formId(): FormIdentifier {
    return this._formId;
  }

  set formId(value) {
    if (JSON.stringify(value) !== JSON.stringify(this._formId)) {
      this._formId = value;
      this.onFormIdChange.next(value);
      this.IrrevocableDesigneeLetterSentValue = null;
    }
  }

  get currentIncentiveProgram(): string {
    return this.projectService.currentIncentiveProgram;
  }

  get projectPayments(): Payment[] {
    return this.projectService.payments;
  }

  get payments(): FormPayment[] {
    const formId = this.formId;
    const projectId = this.projectBase.projectInfo.projectId;

    const paymentsForThisForm = this.projectService.payments.filter(
      pp =>
        pp.paymentProject.projectId === projectId &&
        pp.paymentProject.feeType !== feeTypes.auditorPayment.upperAbbrev &&
        (pp.returnCode === PayPointReturnCode.Success ||
          pp.paymentMethod.toLowerCase() === 'check') &&
        doFormIdsMatch(pp.paymentProject.formId, formId)
    );

    return paymentsForThisForm.map(payment => {
      return <FormPayment>{
        amountPaid: payment.paymentProject.paidAmount,
        confirmationNumber: payment.confirmationNumber,
        createDate: payment.createDate,
        feeType: payment.paymentProject.feeType,
        paymentMethod: payment.paymentMethod,
        requestUrl: payment.requestUrl,
        returnCode: payment.returnCode
      };
    });
  }

  get formCredits(): Credit[] {
    const formId = this.formId;
    // This filter will create a new array,
    // so the reference to credits in projectDetailsService will be broken.
    // Therefore, when adding a new credit to this array do not forget to adding
    // to the credits array in projectDetails Service.
    return this.projectService.filmCredits.filter(credit =>
      doFormIdsMatch(credit.formIdentifier, formId)
    );
  }

  set formCredits(value: Credit[]) {
    this.projectService.filmCredits.push(...value);
  }

  get project(): Project {
    return this.projectService.project;
  }

  get projectBase(): ProjectBase {
    return this.projectService.projectBase;
  }

  get stepProject(): StepProject {

    return this.projectService.stepProject;
  }
  get prrProject(): PrrProject {

    return this.projectService.prrProject;
  }
  set prrProject(value) {
    this.projectService.prrProject = value;
  }

  get filmProject(): FilmProject {
    return this.projectService.filmProject;
  }

  get digitalProject(): DigitalProject {
    return this.projectService.digitalProject;
  }

  get rdProject(): RdProject {
    return this.projectService.rdProject;
  }

  constructor(
    private lookupService: LookupHttpService,
    private projectService: ProjectDetailService,
    private userDataService: UserDataService,
    private signaturesService: SignaturesSendService,
  ) {
    this.actions = [];
    this.onFormIdChange = new Subject<FormIdentifier>();
    this.permissions = new UserFormPermissions();
  }

  determineFeeEffectiveDate(): Date {
    // If the current form's received date, use it
    if (this.form && this.form.receivedDate) {
      return new Date(this.form.receivedDate);
    }

    // Otherwise use current date time
    return new Date();
  }

  getAdvanceFirstReceivedDateOrDefault(): Date {
    let payments = this.projectService.payments;
    payments = payments.filter(pay => pay.paymentProject.formId != null);
    const advancePayments = payments.filter(
      pay => pay.paymentProject.formId.formType === 'advance'
    );
    let advanceReceivedDate = new Date();
    if (this.projectService.project.advance != null) {
      advanceReceivedDate = this.projectService.project.advance.receivedDate
        ? this.projectService.project.advance.receivedDate
        : new Date();
    }
    const paymentDate: Date =
      advancePayments && advancePayments.length > 0
        ? new Date(advancePayments[0].createDate)
        : advanceReceivedDate;
    return paymentDate;
  }

  getLegislationRule(): string {
    let legislationRule = this.projectService.project.projectInfo.legislation;
    if (!this.projectService.project.projectInfo.legislation && this.formId.formType === formTypes.projectApplication.abbrev) {
      legislationRule = legislationRuleNames.ite.Rules2025.name;
    }
    return legislationRule;
  }

  isUserSignee() {
    return this.projectService.isUserBusinessSignatory();
  }

  getFormAssessors(): Observable<User[]> {
    // Gets assessors based on current project parish.
    return this.userDataService.getAssessors(
      this.project.projectInfo.location.parish
    );
  }

  getProgramManager(): Observable<User> {
    // Gets only one program manager per program.
    return this.lookupService.getProgramManager(this.currentIncentiveProgram);
  }

  refreshPage() {
    this.onFormIdChange.next(this.formId);
  }
}
